const AuthHeader = () => {
  return (
    <div className='flex items-center justify-center gap-3 mb-4'>
      <div className='flex items-center justify-center'>
        <img
          src='/smile_logo.png'
          alt='Smile Data Logo'
          className='h-12 w-auto object-contain'
        />
      </div>
      <div>
        <h1 className='text-2xl font-bold text-gray-900'>Smile Data</h1>
        <p className='text-sm text-gray-500'>Healthcare Analytics</p>
      </div>
    </div>
  );
};

export default AuthHeader;
